import { gql } from '@zenbusiness/application-commons-graphql';

export const EVENTS_FRAGMENT = gql`
  fragment eventsFragment on BusinessEntity {
    complianceEvents(eventStatus: $status, eventType: $eventType , pageSize: $pageSize) {
      complianceReports {
        jurisdiction
        dueDate
        status
        type
      }
    }
    
  }
`;

export const HEADER_CARDS_QUERY = gql`
  query HeaderCardsQuery(
    $businessEntityUuid: UUID!
    $status: [ComplianceEventStatusLegacy!]!
    $eventType: ComplianceEventTypeLegacy
    $pageSize: Int
  ) {
    annualReports: complianceEvents(
      businessEntityUuid: $businessEntityUuid
      cursorPage: { pageSize: $pageSize }
      filter: { eventType: annual_report status: [incomplete] }
    ) {
      edges {
        node {
          uuid
          dueDate: dueBy
          type: eventType
          status
          jurisdiction
          jurisdictionType
          createdAt
          updatedAt
        }
      }
    }
    businessEntity(businessEntityUuid: $businessEntityUuid) {
      uuid
      ...eventsFragment
    }
    grantApplication(businessEntityUuid: $businessEntityUuid) {
      status
    }
  }
  ${EVENTS_FRAGMENT}
`;

export const VBA_EVENTS_QUERY = gql`
  query VbaEventsQuery($businessEntityUuid: UUID!, $status: [ComplianceEventStatusLegacy!]!, $eventType: ComplianceEventTypeLegacy, $pageSize: Int){
    businessEntity(businessEntityUuid: $businessEntityUuid) {
      uuid
      documentList(filter: { category: business_record type: form_ps1583 }) {
        results {
          documentUuid
        }
      }
      ...eventsFragment
    }
  }
  ${EVENTS_FRAGMENT}
`;

export const STEPS_TO_SUCCESS_QUERY = gql`
  query StepsToSuccessQuery($businessEntityUuid: UUID!, $status: [ComplianceEventStatusLegacy!]!, $eventType: ComplianceEventTypeLegacy, $pageSize: Int){
    businessEntity(businessEntityUuid: $businessEntityUuid) {
      uuid
      ...eventsFragment
    }
  }
  ${EVENTS_FRAGMENT}
`;

export const FORMATION_TIMELINE_V2_QUERY = gql`
  query FormationTimelineV2($businessEntityUuid: UUID!, $timezone: String!) {
    formationTimelineV2(businessEntityUuid: $businessEntityUuid, timezone: $timezone) {
      hint
      estimatedAt
      estimateAlt
      isOnHold
      currentStep
      currentEvent {
        title
        estimate
        status
        notes
      }
      events {
        estimate
        estimatedAt
        notes
        status
        step
        title
      }
    }
  }
`;

export const MODAL_QUERY = gql`
query ModalQuery($identity: CustomerIdentity!, $constraintOverrides: [ConstraintOverride]) {
  modal(identity: $identity, constraintOverrides: $constraintOverrides) {
    instanceUuid
    uuid
    inAppKey
    topic
    subtitle
    title
    ctaUrl
    ctaType
    ctaLabel
    image
    caption
  }
}`;

export const UPDATE_ACTION_MUTATION = gql`
mutation UpdateActionTaken($input: ActionTaken!) {
  updateActionTaken(input: $input) {
      uuid
      status
  }
}`;

export const NEXTUP_QUERY = gql`
  query NextUpQuery($identity: CustomerIdentity!, $constraintOverrides: [ConstraintOverride]) {
    nextUpCards(identity: $identity, constraintOverrides: $constraintOverrides) {
      instanceUuid
      uuid
      inAppKey
      topic
      title
      description: subtitle
      ctaUrl
      ctaType
      image
      estimate
      tooltip
    }
  }`;
